import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Styles } from './Styles.js';
import {
  ADD_PET_LIST,
  DELETE_FULL_PET_LIST,
  DELETE_PET_LIST_NEW,
} from '../../../../../Store/Slices/InsuredInfo/index.js';
import { UPDATE_LOADING } from '../../../../../Store/Slices/InsuredInfo/index.js';
import { createPetListPayloadNew } from '../../Helper/PetHelper.js';
import { useNavigationHook } from '../../Hooks/NavigationHook.js';
import appConfig from '../../../../../appConfig/index.js';
import Loader from '../../../../Atoms/Loader/index.js';

const PetComponent = (props) => {
  const { currentStep } = useNavigationHook();
  const dispatch = useDispatch();
  const [samlResponseData, setSamlResponseData] = useState(null);
  const [eventDetails, setEventDetails] = useState(null);
  const { employeeIndex } = props;
  const buid = props.employee[employeeIndex]?.personBuid;
  const { insuredInfo } = useSelector((storeState) => storeState);
  const petToken = insuredInfo[currentStep]?.petToken;

  const modalRef = useRef(null);
  const petContainerRef = useRef(null);

  const openModal = () => {
    dispatch(UPDATE_LOADING(false));
    const modalEl = modalRef.current;
    const modal = new window.bootstrap.Modal(modalEl);
    // Clear previous tool
    if (petContainerRef.current) {
      petContainerRef.current.innerHTML = '';
    }
    // Reset state to trigger useEffect
    setSamlResponseData(null);
    // Show modal and then set saml token after small delay
    modal.show();
    setTimeout(() => {
      setSamlResponseData(petToken);
    }, 200); // delay to ensure modal is open before injection
  };

  const closeModal = () => {
    const modalEl = modalRef.current;
    if (modalEl) {
      const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
      modalInstance?.hide();
    }
  };

  const loadPet = () => {
    try {
      const container = petContainerRef.current;
      if (!container || !samlResponseData) return;

      container.innerHTML = '';
      const petTool = document.createElement('nw-pet');
      petTool.setAttribute('type-id', appConfig.NATIONWIDE_TYPE_ID);
      petTool.setAttribute('client-id', appConfig.NATIONWIDE_CLIENT_ID);
      petTool.setAttribute('bypass-splash', 'true');
      petTool.setAttribute('saml-response', samlResponseData);
      petTool.setAttribute(
        'post-back',
        "document.dispatchEvent(new CustomEvent('partnerEvent', { detail: event.detail }));"
      );
      container.appendChild(petTool);
    } catch (error) {
      console.error('Error loading PET tool:', error);
      dispatch(UPDATE_LOADING(false));
    }
  };

  // Inject nw-pet when samlResponseData changes
  useEffect(() => {
    if (!samlResponseData) return;
    loadPet();
    try {
      customElements.whenDefined('nw-pet').then(() => {
        const checkRendered = setInterval(() => {
          const nwPetEl = document.querySelector('nw-pet');
          if (nwPetEl?.shadowRoot) {
            dispatch(UPDATE_LOADING(false));
            clearInterval(checkRendered);
          }
        }, 100);
      });
    } catch (error) {
      console.error('Failed to initialize nw-pet element:', error);
      dispatch(UPDATE_LOADING(false));
    }
  }, [samlResponseData]);

  // Listen for partnerEvent (EXIT, APPSUB, etc.)
  useEffect(() => {
    const handlePartnerEvent = (event) => {
      console.log('Received partnerEvent:', event.detail);
      const detail = event.detail;
      setEventDetails(detail);
      if (detail?.eventType === 'APPSUB'||detail?.eventType === 'APPUPD') {
        const petListPayload = createPetListPayloadNew(detail?.pets || []);
        dispatch(DELETE_FULL_PET_LIST({ product: currentStep, petList: [] }));
        dispatch(ADD_PET_LIST({ product: currentStep, petList: petListPayload }));
      }
      if (detail?.eventType === 'APPCNL') {
        dispatch(DELETE_FULL_PET_LIST({ product: currentStep, petList: [] }));
        const petListPayload = createPetListPayloadNew(detail?.pets || []);
        if (petListPayload.length > 0) {
          dispatch(DELETE_PET_LIST_NEW({ product: currentStep, petListUpdated: petListPayload }));
        }
      }
      if (detail?.eventType === 'EXIT') {
        console.log('Exiting Pet Assure modal');
        closeModal();
      }
    };

    document.addEventListener('partnerEvent', handlePartnerEvent);
    return () => {
      document.removeEventListener('partnerEvent', handlePartnerEvent);
    };
  }, [currentStep]);

  return (
    <>
      <Styles />
      <div className="py-3">
        <button
          type="button"
          className="btn btn-outline-primary primaryOutline"
          onClick={openModal}
        >
          Enroll Pet
        </button>
      </div>

      <div className="member-container-pet">
        <div
          className="modal fade"
          id="petNationWideModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          ref={modalRef}
        >
          <div className="modal-dialog modal-xl modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Enroll Pet</h4>
                {!samlResponseData && (
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={closeModal}
                  >
                    X
                  </button>
                )}
              </div>

              <div className="modal-body mt-0 pt-0">
                {!samlResponseData ? (
                  <h6 style={{ textAlign: 'center' }}>
                    Unable to process your request at this time. Please try again later.
                  </h6>
                ) : (
                  <div ref={petContainerRef}></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PetComponent;
